import { render, staticRenderFns } from "./TableValidatorsTeam.vue?vue&type=template&id=af3a4fd0&"
import script from "./TableValidatorsTeam.vue?vue&type=script&lang=js&"
export * from "./TableValidatorsTeam.vue?vue&type=script&lang=js&"
import style0 from "./TableValidatorsTeam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports